const onLoad = <E extends Element = Element>(selectors: string, handler: ($item: E) => void) => {
  if (document.readyState === 'complete') {
    document.querySelectorAll<E>(selectors).forEach(handler);
  } else {
    window.addEventListener('DOMContentLoaded', () => {
      document.querySelectorAll<E>(selectors).forEach(handler);
    });
  }
};

export default onLoad;
